export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', color: 'bg-accent-100', textColor: 'text-accent-700' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', color: 'bg-secondary-100', textColor: 'text-secondary-700' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line', color: 'bg-background-200', textColor: 'text-foreground-700' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', color: 'bg-primary-100', textColor: 'text-primary-700' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line', color: 'bg-accent-100', textColor: 'text-accent-700' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'bg-secondary-100', textColor: 'text-secondary-700' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', color: 'bg-background-200', textColor: 'text-foreground-700' },
  { slug: 'history', name: '历史', icon: 'ri-ancient-gate-line', color: 'bg-primary-100', textColor: 'text-primary-700' },
];

export const comics = [
  {
    id: '1',
    title: '我的野蛮王妃',
    slug: 'my-sassy-princess',
    author: '朴秀晶',
    category: 'love',
    description: '一个普通女孩意外嫁入皇室的故事，在宫廷的权力斗争与爱情的纠葛中，她能否守住自己的真心？每周更新，精彩不容错过。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%2C%20elegant%20couple%20in%20royal%20palace%20setting%2C%20soft%20pink%20and%20gold%20color%20scheme%2C%20beautiful%20digital%20illustration%2C%20clean%20simple%20background%20with%20subtle%20flower%20petals%2C%20manga%20style%20artwork&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    views: '1280万',
    status: '连载中',
    totalChapters: 156,
    latestChapter: 156,
    tags: ['恋爱', '宫廷', '浪漫'],
  },
  {
    id: '2',
    title: '暗夜追踪者',
    slug: 'night-tracker',
    author: '金在勋',
    category: 'suspense',
    description: '连环杀人案背后的真相究竟是什么？刑警韩志浩在追查过程中发现了一个惊天的秘密。紧张刺激的悬疑推理漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20suspense%20comic%20cover%2C%20detective%20in%20dark%20alley%20with%20flashlight%2C%20mysterious%20atmosphere%2C%20cool%20teal%20and%20dark%20blue%20tones%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20manga%20style&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    views: '960万',
    status: '连载中',
    totalChapters: 89,
    latestChapter: 89,
    tags: ['悬疑', '推理', '犯罪'],
  },
  {
    id: '3',
    title: '都市夜话',
    slug: 'city-nights',
    author: '李敏雅',
    category: 'urban',
    description: '在首尔的繁华都市中，几个年轻人的职场与爱情故事。真实而温暖的都市生活图鉴，让你感同身受。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20life%20comic%20cover%2C%20young%20professionals%20in%20Seoul%20cityscape%20at%20night%2C%20warm%20apartment%20lighting%2C%20modern%20lifestyle%2C%20neutral%20gray%20and%20warm%20beige%20tones%2C%20clean%20digital%20illustration&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    rating: 9.1,
    views: '850万',
    status: '连载中',
    totalChapters: 120,
    latestChapter: 120,
    tags: ['都市', '职场', '爱情'],
  },
  {
    id: '4',
    title: '龙之继承者',
    slug: 'dragon-heir',
    author: '崔元浩',
    category: 'fantasy',
    description: '拥有龙之血脉的少年踏上冒险之路，在魔法与剑的世界中书写传奇。宏大奇幻世界观，震撼视觉体验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20comic%20cover%2C%20young%20hero%20with%20dragon%20companion%2C%20magical%20realm%2C%20warm%20golden%20and%20amber%20color%20scheme%2C%20epic%20fantasy%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    rating: 9.7,
    views: '1520万',
    status: '连载中',
    totalChapters: 210,
    latestChapter: 210,
    tags: ['奇幻', '冒险', '魔法'],
  },
  {
    id: '5',
    title: '极速传说',
    slug: 'speed-legend',
    author: '张东健',
    category: 'action',
    description: '地下赛车世界中的热血故事，速度与激情的碰撞。主人公为梦想而战，在极限中突破自我。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20racing%20comic%20cover%2C%20street%20racing%20scene%20with%20sports%20car%2C%20dynamic%20motion%20blur%2C%20vibrant%20red%20and%20dark%20tones%2C%20exciting%20atmosphere%2C%20manga%20style%20digital%20art&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    rating: 9.0,
    views: '720万',
    status: '已完结',
    totalChapters: 95,
    latestChapter: 95,
    tags: ['动作', '赛车', '热血'],
  },
  {
    id: '6',
    title: '恋爱方程式',
    slug: 'love-formula',
    author: '郑恩智',
    category: 'love',
    description: '学霸与学渣之间的爆笑恋爱故事。当理性遇上感性，当高冷遇上热情，会碰撞出怎样的火花？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20comic%20cover%2C%20cute%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20soft%20pink%20and%20white%20color%20palette%2C%20sweet%20atmosphere%2C%20clean%20manga%20illustration&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    views: '1100万',
    status: '连载中',
    totalChapters: 78,
    latestChapter: 78,
    tags: ['恋爱', '校园', '搞笑'],
  },
  {
    id: '7',
    title: '鬼校异闻录',
    slug: 'ghost-school',
    author: '沈贤宇',
    category: 'horror',
    description: '一所废弃学校中隐藏的恐怖秘密。每当午夜钟声响起，不可思议的事情就会发生。胆小者慎入！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20school%20comic%20cover%2C%20abandoned%20school%20corridor%20with%20eerie%20atmosphere%2C%20dark%20shadows%2C%20cold%20gray%20and%20dark%20green%20tones%2C%20spooky%20manga%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    rating: 8.9,
    views: '680万',
    status: '连载中',
    totalChapters: 56,
    latestChapter: 56,
    tags: ['恐怖', '校园', '灵异'],
  },
  {
    id: '8',
    title: '搞笑一家人',
    slug: 'funny-family',
    author: '刘在石',
    category: 'comedy',
    description: '一个四口之家的爆笑日常生活。妈妈是料理黑洞，爸爸是游戏宅，两个孩子更是让人哭笑不得。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20family%20comic%20cover%2C%20funny%20family%20of%20four%2C%20chaotic%20living%20room%20scene%2C%20bright%20yellow%20and%20warm%20orange%20colors%2C%20humorous%20digital%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    rating: 9.4,
    views: '1350万',
    status: '连载中',
    totalChapters: 180,
    latestChapter: 180,
    tags: ['搞笑', '家庭', '日常'],
  },
  {
    id: '9',
    title: '朝鲜王朝秘史',
    slug: 'joseon-secret',
    author: '金秀贤',
    category: 'history',
    description: '以朝鲜王朝为背景的历史权谋漫画。宫廷斗争、爱恨情仇，在历史的洪流中寻找真相。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20comic%20cover%2C%20Joseon%20dynasty%20palace%20scene%2C%20traditional%20Korean%20hanbok%20costumes%2C%20warm%20earth%20tones%20and%20gold%2C%20elegant%20classical%20illustration%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    rating: 9.6,
    views: '980万',
    status: '已完结',
    totalChapters: 200,
    latestChapter: 200,
    tags: ['历史', '权谋', '宫廷'],
  },
  {
    id: '10',
    title: '魔法学院',
    slug: 'magic-academy',
    author: '安孝珍',
    category: 'fantasy',
    description: '平凡少年意外进入魔法学院，在魔法与友情的陪伴下逐渐成长。经典魔法校园题材的全新演绎。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20comic%20cover%2C%20students%20in%20magical%20school%20uniform%2C%20floating%20spells%20and%20books%2C%20mystical%20purple%20and%20blue%20tones%2C%20enchanting%20atmosphere%2C%20clean%20digital%20illustration&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    views: '890万',
    status: '连载中',
    totalChapters: 142,
    latestChapter: 142,
    tags: ['奇幻', '魔法', '校园'],
  },
  {
    id: '11',
    title: '午夜咖啡厅',
    slug: 'midnight-cafe',
    author: '韩素希',
    category: 'urban',
    description: '一家只在午夜营业的神秘咖啡厅，每位客人都带着不为人知的故事。温暖治愈的都市小品。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20night%20cafe%20comic%20cover%2C%20cozy%20cafe%20interior%20at%20night%2C%20warm%20lamp%20lighting%2C%20emotional%20atmosphere%2C%20soft%20brown%20and%20cream%20tones%2C%20healing%20manga%20style%20illustration&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    rating: 9.1,
    views: '650万',
    status: '连载中',
    totalChapters: 67,
    latestChapter: 67,
    tags: ['都市', '治愈', '情感'],
  },
  {
    id: '12',
    title: '武道巅峰',
    slug: 'martial-peak',
    author: '姜虎东',
    category: 'action',
    description: '从底层崛起的武道天才，一路挑战各路高手。酣畅淋漓的战斗场面，让人热血沸腾。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20comic%20cover%2C%20fighter%20in%20dynamic%20action%20pose%2C%20energy%20effects%2C%20intense%20red%20and%20black%20color%20scheme%2C%20powerful%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    rating: 9.5,
    views: '1450万',
    status: '连载中',
    totalChapters: 245,
    latestChapter: 245,
    tags: ['动作', '武道', '热血'],
  },
  {
    id: '13',
    title: '心动信号',
    slug: 'heart-signal',
    author: '宋智孝',
    category: 'love',
    description: '恋爱真人秀题材的浪漫漫画。在镜头前展现的真实与虚假，谁才是真心人？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dating%20show%20romance%20comic%20cover%2C%20attractive%20couple%20on%20TV%20set%2C%20studio%20lighting%2C%20glamorous%20vibe%2C%20rose%20gold%20and%20cream%20tones%2C%20clean%20manga%20illustration&width=800&height=1120&seq=comic-cover-13&orientation=portrait',
    rating: 8.8,
    views: '580万',
    status: '连载中',
    totalChapters: 45,
    latestChapter: 45,
    tags: ['恋爱', '综艺', '浪漫'],
  },
  {
    id: '14',
    title: '异世界食堂',
    slug: 'isekai-restaurant',
    author: '朴宝剑',
    category: 'fantasy',
    description: '普通餐厅通往异世界的大门打开，各路奇幻生物慕名而来品尝人间美食。美食与奇幻的完美结合。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20food%20comic%20cover%2C%20magical%20restaurant%20with%20fantasy%20creatures%2C%20delicious%20food%20displays%2C%20warm%20golden%20and%20green%20tones%2C%20whimsical%20illustration%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-14&orientation=portrait',
    rating: 9.0,
    views: '760万',
    status: '连载中',
    totalChapters: 88,
    latestChapter: 88,
    tags: ['奇幻', '美食', '异世界'],
  },
  {
    id: '15',
    title: '死亡游戏',
    slug: 'death-game',
    author: '柳俊烈',
    category: 'suspense',
    description: '被困在神秘游戏中的一群人，只有最后的幸存者才能离开。人性的考验与智力的较量。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20death%20game%20thriller%20comic%20cover%2C%20players%20in%20mysterious%20arena%2C%20tense%20survival%20atmosphere%2C%20dark%20red%20and%20black%20tones%2C%20intense%20manga%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-15&orientation=portrait',
    rating: 9.4,
    views: '1050万',
    status: '连载中',
    totalChapters: 102,
    latestChapter: 102,
    tags: ['悬疑', '生存', '游戏'],
  },
  {
    id: '16',
    title: '办公室罗曼史',
    slug: 'office-romance',
    author: '金智媛',
    category: 'urban',
    description: '广告公司里的办公室恋情，上司与下属之间微妙的感情变化。成熟的都市爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comic%20cover%2C%20elegant%20couple%20in%20modern%20office%2C%20professional%20attire%2C%20sophisticated%20gray%20and%20blush%20tones%2C%20mature%20manga%20illustration%2C%20clean%20composition&width=800&height=1120&seq=comic-cover-16&orientation=portrait',
    rating: 8.7,
    views: '520万',
    status: '已完结',
    totalChapters: 72,
    latestChapter: 72,
    tags: ['都市', '办公室', '爱情'],
  },
];

export const reviews = [
  {
    id: '1',
    userName: '漫画迷小鹿',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20fashionable%20young%20woman%20portrait%20avatar%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20background%2C%20warm%20friendly%20expression%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    content: '韩漫漫画网真的是我找到的最好的韩漫阅读平台！无遮挡下拉式阅读体验太棒了，画质清晰，加载速度也很快。最重要的是完全免费，更新也很及时，每天都有新内容可以追。',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: '2',
    userName: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20casual%20portrait%20avatar%2C%20soft%20evening%20lighting%2C%20clean%20simple%20background%2C%20friendly%20smile%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    content: '每天晚上睡前都要来刷一遍更新，已经养成了习惯。分类很细，找漫画特别方便。强烈推荐给所有喜欢韩漫的朋友！',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: '3',
    userName: '漫画控小Q',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20cute%20young%20woman%20portrait%20avatar%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20cheerful%20smile%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    content: '从日漫转过来的，发现韩漫也别有一番风味。这里的漫画种类真的很全，恋爱、悬疑、奇幻什么都有。而且阅读界面非常简洁，体验感满分！',
    rating: 4,
    date: '2026-06-20',
  },
];

export const editorPick = {
  editorName: '金智秀',
  title: '首席内容主编',
  content: '在韩漫漫画网，我们坚持为每一位读者提供最优质的漫画阅读体验。每一部作品都经过精心筛选，确保画质与内容的高水准。我们相信，好的漫画能够跨越语言和文化的界限，带给读者最纯粹的快乐与感动。',
};

export const aboutData = {
  brandName: '韩漫漫画网',
  vision: '成为全球韩漫爱好者首选的阅读平台',
  foundedYear: '2020',
  stats: [
    { label: '收录作品', value: '5000+' },
    { label: '活跃用户', value: '208万' },
    { label: '累计阅读', value: '8.6亿次' },
    { label: '每日更新', value: '200+话' },
  ],
  contact: {
    email: 'hello@vktest.com',
    phone: '400-888-0000',
    address: '北京市朝阳区望京SOHO T1 1208室',
  },
  socialLinks: [
    { name: '微博', url: '#', icon: 'ri-weibo-line' },
    { name: '微信', url: '#', icon: 'ri-wechat-line' },
    { name: 'QQ', url: '#', icon: 'ri-qq-line' },
    { name: 'B站', url: '#', icon: 'ri-bilibili-line' },
  ],
};